// frontend/src/PaymentComponent.js

import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

// Replace with your actual publishable key
const stripePromise = loadStripe('pk_test_your_publishable_key');

function CheckoutForm({ eventId, amountInCents, onSuccess }) {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMsg, setErrorMsg] = useState('');
  const [processing, setProcessing] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setProcessing(true);

    // Create a PaymentIntent by calling your backend endpoint
    const response = await fetch('/api/create-event-payment-session/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ event_id: eventId, amount: amountInCents })
    });
    const data = await response.json();
    if (data.error) {
      setErrorMsg(data.error);
      setProcessing(false);
      return;
    }

    // Confirm the card payment using the client_secret from the PaymentIntent
    const cardElement = elements.getElement(CardElement);
    const result = await stripe.confirmCardPayment(data.client_secret, {
      payment_method: {
        card: cardElement,
        billing_details: {
          // Optionally collect and pass billing details here
          name: 'Assistant Name'
        },
      },
    });

    if (result.error) {
      setErrorMsg(result.error.message);
      setProcessing(false);
    } else {
      if (result.paymentIntent.status === 'succeeded') {
        onSuccess();
      }
      setProcessing(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <CardElement options={{ hidePostalCode: true }} />
      {errorMsg && <div style={{ color: 'red' }}>{errorMsg}</div>}
      <button type="submit" disabled={!stripe || processing}>
        {processing ? 'Processing…' : 'Pay Now'}
      </button>
    </form>
  );
}

export default function PaymentComponent({ eventId, amountInCents, onSuccess }) {
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm eventId={eventId} amountInCents={amountInCents} onSuccess={onSuccess} />
    </Elements>
  );
}

